String.prototype.removeLastSlash = function () {
    const str = this.toString();
    if (str.endsWith('/')) {
        return str.slice(0, -1); // Remove last character
    }
    return str;
};
  
export const STUDIOS_COLORS = {
    1: "green",
    2: "black",
    3: "red",
    4: "#9B59B6",
    5: "#F1C40F"
}

export const CHINES_STUDIO_ID = 2;
export const SHUFFLERS_STUDIO_ID = 6;

export const IMAGE_UPLOAD_URL =  process.env.REACT_APP_API_URL.removeLastSlash()+"/uploads/";